module.exports = __webpack_public_path__ + "img/icon-58.9daf6fed.svg";